import React, { ReactNode } from 'react';
import { Box, SxProps } from '@mui/material';

import ScrollableContainer from '@components/ScrollableContainer';

import { useStyles } from './styles';

const ModalContainer = ({
  children,
  header = null,
  isScrollable = true,
  sx = {},
}: {
  children: ReactNode;
  header?: ReactNode | null;
  isScrollable?: boolean;
  sx?: SxProps;
}) => {
  const classes = useStyles();

  const renderContent = () => {
    if (isScrollable) {
      return (
        <ScrollableContainer
          sxProps={{ root: classes.tabContent, content: classes.content }}
        >
          {children}
        </ScrollableContainer>
      );
    }

    return <Box sx={classes.content}>{children}</Box>;
  };

  return (
    <Box sx={{ ...classes.root, ...sx }}>
      {header}
      {renderContent()}
    </Box>
  );
};

export default ModalContainer;
